
export interface Tomo {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const tomos: Tomo[] = [
  {
    number: '01',
    title: 'Protocolo de Anamnesis de Alto Impacto',
    description:
      'Detectá la raíz del problema en los primeros 15 minutos de consulta. Sistema de preguntas filtro, evaluación clínica integral y cierre con compromiso.',
    tag: '50 páginas · Casos clínicos incluidos',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/o3vRZnpQnuqdiTVgfR1xDE/tomo_1_nutri_pro.webp',
  },
  {
    number: '02',
    title: 'Laboratorio y Bioquímica para Nutricionistas',
    description:
      'Interpretá análisis de sangre con criterio clínico real. Ajustá planes según valores bioquímicos con protocolos paso a paso.',
    tag: '50 páginas · Tablas de referencia incluidas',
    coverImage: 'https://cdn.magicpatterns.com/uploads/w9BQ62539rVxnx9FFbzsTE/tomo_2_nutri.webp',
  },
  {
    number: '03',
    title: 'Ingeniería de Planes Semanales',
    description:
      'Construí menús personalizados en menos de 5 minutos con el Sistema de Bloques Nutricionales™. Sin empezar desde cero nunca más.',
    tag: '50 páginas · Biblioteca de bloques incluida',
    coverImage: 'https://cdn.magicpatterns.com/uploads/j5UntC73pRuw4wmyfeU5N4/tomo_3_nutri.png',
  },
  {
    number: '04',
    title: 'Nutrición Clínica Aplicada',
    description:
      'Protocolos basados en evidencia para diabetes, SOP, hipotiroidismo, dislipidemia, obesidad y patología gastrointestinal.',
    tag: '50 páginas · 6 protocolos clínicos',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/bCyiYGDAART1xBK6zQGEQq/tomo_4_nutri_(3).png',
  },
  {
    number: '05',
    title: 'Educación Alimentaria Visual',
    description:
      'Guías claras para explicar porciones, etiquetas y hábitos. Sistema de Porciones con la Mano™ y Plato Nutri-Pro™ adaptado a LATAM.',
    tag: '50 páginas · Materiales para pacientes',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/n1oJNVtNZwLAekr5Qr2LT4/tomo_5_nutri_(2).png',
  },
  {
    number: '06',
    title: 'Adherencia, Seguimiento y Práctica Profesional',
    description:
      'Estrategias para sostener tratamientos, retener pacientes, profesionalizar el consultorio y gestionar la consulta virtual.',
    tag: '50 páginas · Protocolos de retención',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/fd2HvtoLT2L1QNUt3nVwdi/tomo_6_nutri_(2).png',
  },
];

export interface Bono {
  badge: string;
  icon: string;
  title: string;
  description: string;
  value: string;
}

export const bonos: Bono[] = [
  {
    badge: 'BONO 1',
    icon: '💬',
    title: 'Kit de WhatsApp y Recordatorios',
    description:
      'Más de 130 mensajes profesionales listos para copiar y pegar. Confirmación de turnos, acompañamiento entre sesiones, manejo de situaciones críticas y retención.',
    value: 'Valor: $47 USD',
  },
  {
    badge: 'BONO 2',
    icon: '📊',
    title: 'Plantilla de Análisis de Composición Corporal',
    description:
      'Sistema completo de registro e interpretación de composición corporal. Dashboard de progreso clínico y protocolos de comunicación de resultados al paciente.',
    value: 'Valor: $47 USD',
  },
  {
    badge: 'BONO 3',
    icon: '⚖️',
    title: 'Guía Legal y Consentimientos para Consulta Nutricional',
    description:
      'Consentimientos informados, contratos de servicios, política de privacidad y documentos de protección profesional listos para usar en toda LATAM.',
    value: 'Valor: $47 USD',
  },
  {
    badge: 'BONO 4',
    icon: '💊',
    title: 'Directorio de Suplementación Inteligente',
    description:
      'Criterios clínicos basados en evidencia para orientar suplementación por patología, objetivo y etapa de vida. Tabla de interacciones con medicamentos.',
    value: 'Valor: $47 USD',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  city: string;
  role: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'Llevaba años improvisando cada consulta. Con este sistema armé una estructura real de trabajo en menos de una semana. El Tomo 3 solo ya valió cada centavo.',
    name: 'Valentina R.',
    city: 'Buenos Aires, Argentina',
    role: 'Nutricionista clínica independiente',
    initials: 'VR',
  },
  {
    text: 'El Kit de WhatsApp del Bono 1 me cambió la forma de comunicarme con mis pacientes. Bajaron mis cancelaciones de último momento y subió la adherencia al tratamiento.',
    name: 'Daniela M.',
    city: 'Ciudad de México, México',
    role: 'Nutricionista y coach de hábitos',
    initials: 'DM',
  },
  {
    text: 'Los protocolos clínicos del Tomo 4 son exactamente lo que necesitaba para abordar pacientes con SOP e hipotiroidismo con más seguridad y menos dudas.',
    name: 'Carolina S.',
    city: 'Bogotá, Colombia',
    role: 'Nutricionista especializada en salud hormonal',
    initials: 'CS',
  },
  {
    text: 'Pensé que era un PDF más. Resultó ser el recurso más completo que tengo en mi consultorio. La Guía Legal del Bono 3 la uso en cada consulta nueva.',
    name: 'Francisca T.',
    city: 'Santiago, Chile',
    role: 'Nutricionista clínica y deportiva',
    initials: 'FT',
  },
  {
    text: 'Lo compré desde Perú sin problema, el pago se procesó en soles automáticamente y descargué todo en minutos. El contenido es de un nivel que no encontré en ningún otro recurso en español.',
    name: 'Alejandra V.',
    city: 'Lima, Perú',
    role: 'Nutricionista hospitalaria',
    initials: 'AV',
  },
  {
    text: 'El Sistema de Bloques Nutricionales del Tomo 3 me ahorró horas de trabajo por semana. Ahora armo planes en minutos y el paciente los entiende mejor.',
    name: 'Mariana F.',
    city: 'Montevideo, Uruguay',
    role: 'Nutricionista pediátrica y familiar',
    initials: 'MF',
  },
  {
    text: 'Trabajo en consulta virtual desde Venezuela y el sistema funciona perfecto para ese formato. El Tomo 6 tiene todo lo que necesitaba para profesionalizar mi práctica online.',
    name: 'Gabriela P.',
    city: 'Caracas, Venezuela',
    role: 'Nutricionista online LATAM',
    initials: 'GP',
  },
];

export interface Notification {
  name: string;
  location: string;
  time: string;
}

export const notifications: Notification[] = [
  { name: 'Valentina R.', location: 'Buenos Aires, Argentina', time: 'hace 2 minutos' },
  { name: 'Daniela M.', location: 'Ciudad de México, México', time: 'hace 5 minutos' },
  { name: 'Carolina S.', location: 'Bogotá, Colombia', time: 'hace 8 minutos' },
  { name: 'Francisca T.', location: 'Santiago, Chile', time: 'hace 11 minutos' },
  { name: 'Alejandra V.', location: 'Lima, Perú', time: 'hace 14 minutos' },
  { name: 'Mariana F.', location: 'Montevideo, Uruguay', time: 'hace 18 minutos' },
  { name: 'Gabriela P.', location: 'Caracas, Venezuela', time: 'hace 22 minutos' },
  { name: 'Sofía R.', location: 'Rosario, Argentina', time: 'hace 26 minutos' },
  { name: 'Camila V.', location: 'Guadalajara, México', time: 'hace 31 minutos' },
  { name: 'Isabella M.', location: 'Medellín, Colombia', time: 'hace 35 minutos' },
  { name: 'Catalina R.', location: 'Valparaíso, Chile', time: 'hace 41 minutos' },
  { name: 'Luciana B.', location: 'Córdoba, Argentina', time: 'hace 47 minutos' },
  { name: 'Renata S.', location: 'São Paulo, Brasil', time: 'hace 52 minutos' },
  { name: 'Andrea C.', location: 'Quito, Ecuador', time: 'hace 58 minutos' },
  { name: 'Jimena P.', location: 'Asunción, Paraguay', time: 'hace 1 hora' },
  { name: 'Natalia F.', location: 'La Paz, Bolivia', time: 'hace 1 hora y 8 min' },
  { name: 'Paola M.', location: 'San José, Costa Rica', time: 'hace 1 hora y 15 min' },
  { name: 'Valeria T.', location: 'Guatemala, Guatemala', time: 'hace 1 hora y 24 min' },
  { name: 'Mónica R.', location: 'Montevideo, Uruguay', time: 'hace 1 hora y 33 min' },
  { name: 'Stephanie L.', location: 'Managua, Nicaragua', time: 'hace 1 hora y 45 min' },
];

export const faqs = [
  {
    question: '¿Cómo recibo el sistema después de comprar?',
    answer:
      'Recibís acceso inmediato a los 10 archivos PDF apenas se confirma el pago. Sin esperas, sin aplicaciones y desde cualquier dispositivo. La descarga es instantánea.',
  },
  {
    question: '¿El pago es único o es una suscripción?',
    answer:
      'Es un pago único de $17 USD. No hay suscripciones, cargos recurrentes ni costos ocultos. Accedés al sistema completo de por vida.',
  },
  {
    question: '¿Puedo comprarlo desde mi país?',
    answer:
      'Sí. El sistema está disponible para toda LATAM. La plataforma detecta tu país y convierte automáticamente el precio a tu moneda local antes de confirmar el pago.',
  },
  {
    question: '¿Qué pasa si no me sirve?',
    answer:
      'Tenés una garantía de 7 días sin preguntas. Si dentro de la primera semana no es lo que esperabas, te devolvemos el 100% de tu inversión. Sin trámites complicados.',
  },
  {
    question: '¿Es un curso con videos o certificación?',
    answer:
      'No. Es un sistema digital de consulta en formato PDF, listo para aplicar. No incluye clases en video ni certificación académica: es contenido clínico práctico para usar hoy mismo.',
  },
  {
    question: '¿Necesito instalar algo para usarlo?',
    answer:
      'No. Son archivos PDF que abrís en cualquier dispositivo: celular, tablet o computadora. Sin aplicaciones ni software adicional.',
  },
];

